module.exports = __webpack_public_path__ + "static/media/search2.c634ac3a.svg";